import accountSales from './accountSales.json';
import addressForm from './addressForm.json';
import advancedCustomerSearch from './advancedCustomerSearch.json';
import alerts from './alerts.json';
import billTable from './billTable.json';
import campaigns from './campaigns.json';
import cashInOut from './cashInOut.json';
import changePassword from './changePassword.json';
import changePin from './changePin.json';
import clockInOut from './clockInOut.json';
import common from './common.json';
import contacts from './contacts.json';
import createCustomer from './createCustomer.json';
import createNew from './createNew.json';
import customPrompts from './customPrompts.json';
import customer from './customer.json';
import customerButtons from './customerButtons.json';
import customerInformation from './customerInformation.json';
import customerNotes from './customerNotes.json';
import customerSearch from './customerSearch.json';
import discount from './discount.json';
import discountPopup from './discountPopup.json';
import editEmployee from './editEmployee.json';
import employee from './employee.json';
import employeeStats from './employeeStats.json';
import fiscalIntegration from './fiscalIntegration.json';
import giftcard from './giftcard.json';
import gridButtons from './gridButtons.json';
import header from './header.json';
import installer from './installer.json';
import layaway from './layaway.json';
import limitPerSale from './limitPerSale.json';
import localDBs from './localDBs.json';
import login from './login.json';
import managerOverride from './managerOverride.json';
import modalpage from './modalpage.json';
import multiCurrency from './multiCurrency.json';
import offer from './offer.json';
import offlineLogin from './offlineLogin.json';
import openCloseDay from './openCloseDay.json';
import order from './order.json';
import orderAssignment from './orderAssignment.json';
import payCheckForm from './payCheckForm.json';
import payment from './payment.json';
import paymentIntegrations from './paymentIntegrations.json';
import pluginCustomerDisplay from './plugin-customerDisplay.json';
import printCoupons from './printCoupons.json';
import product from './product.json';
import productGroup from './productGroup.json';
import productGroupEditTexts from './productGroupEditTexts.json';
import productSearch from './productSearch.json';
import returnTranslations from './return.json';
import sale from './sale.json';
import saleNotes from './saleNotes.json';
import search from './search.json';
import Sentry from './Sentry.json';
import sessionExpiration from './sessionExpiration.json';
import settings from './settings.json';
import settingsAgeVerification from './settingsAgeVerification.json';
import settingsAssociatePos from './settingsAssociatePos.json';
import settingsCompany from './settingsCompany.json';
import settingsConfiguration from './settingsConfiguration.json';
import settingsCustomPayment from './settingsCustomPayment.json';
import settingsCustomer from './settingsCustomer.json';
import settingsCustomerDisplay from './settingsCustomerDisplay.json';
import settingsCustomerSearchResults from './settingsCustomerSearchResults.json';
import settingsEmployees from './settingsEmployees.json';
import settingsLanguage from './settingsLanguage.json';
import settingsNoteButtons from './settingsNoteButtons.json';
import settingsOnScreenKeyboard from './settingsOnScreenKeyboard.json';
import settingsPayment from './settingsPayment.json';
import settingsPrinter from './settingsPrinter.json';
import settingsReceiptTemplates from './settingsReceiptTemplates.json';
import settingsTaxRates from './settingsTaxRates.json';
import settingsUserInterface from './settingsUserInterface.json';
import shipping from './shipping.json';
import shoppingCart from './shoppingCart.json';
import shortcuts from './shortcuts.json';
import stockTransfer from './stockTransfer.json';
import taxExempt from './taxExempt.json';
import unpaidInvoice from './unpaidInvoice.json';
import validation from './validation.json';
import zReport from './zReport.json';

export const de = {
  accountSales,
  addressForm,
  advancedCustomerSearch,
  alerts,
  billTable,
  campaigns,
  cashInOut,
  changePassword,
  changePin,
  clockInOut,
  common,
  contacts,
  createCustomer,
  createNew,
  customPrompts,
  customer,
  customerButtons,
  customerInformation,
  customerNotes,
  customerSearch,
  discount,
  discountPopup,
  editEmployee,
  employee,
  employeeStats,
  fiscalIntegration,
  giftcard,
  gridButtons,
  header,
  installer,
  layaway,
  limitPerSale,
  localDBs,
  login,
  managerOverride,
  modalpage,
  multiCurrency,
  offer,
  offlineLogin,
  openCloseDay,
  order,
  orderAssignment,
  payCheckForm,
  payment,
  paymentIntegrations,
  'plugin-customerDisplay': pluginCustomerDisplay,
  printCoupons,
  product,
  productGroup,
  productGroupEditTexts,
  productSearch,
  return: returnTranslations,
  sale,
  saleNotes,
  search,
  Sentry,
  sessionExpiration,
  settings,
  settingsAgeVerification,
  settingsAssociatePos,
  settingsCompany,
  settingsConfiguration,
  settingsCustomPayment,
  settingsCustomer,
  settingsCustomerDisplay,
  settingsCustomerSearchResults,
  settingsEmployees,
  settingsLanguage,
  settingsNoteButtons,
  settingsOnScreenKeyboard,
  settingsPayment,
  settingsPrinter,
  settingsReceiptTemplates,
  settingsTaxRates,
  settingsUserInterface,
  shipping,
  shoppingCart,
  shortcuts,
  stockTransfer,
  taxExempt,
  unpaidInvoice,
  validation,
  zReport,
};
